// extracted by mini-css-extract-plugin
export default {"cardList":"CardView-module__cardList--RDT2W","card":"CardView-module__card--WDVx9","cardRow":"CardView-module__cardRow--SPa1g","cardRowTitle":"CardView-module__cardRowTitle--_V9l7"};